import { DocumentType } from '@paeffgen/react/crm-documents/data-access-graphql';

/**
 * Badge CSS classes per document type (Tailwind).
 * Used consistently across document lists, detail views, and modals.
 */
export const TYPE_BADGES: Record<DocumentType, string> = {
  [DocumentType.ANGEBOT]: 'bg-status-offer-soft text-status-offer border-status-offer/20',
  [DocumentType.AUFTRAG]: 'bg-status-order-soft text-status-order border-status-order/20',
  [DocumentType.LIEFERSCHEIN]: 'bg-status-delivery-soft text-status-delivery border-status-delivery/20',
  [DocumentType.RECHNUNG]: 'bg-status-invoice-soft text-status-invoice border-status-invoice/20',
  [DocumentType.GUTSCHRIFT]: 'bg-status-credit-soft text-status-credit border-status-credit/20',
};

/**
 * Human-readable German labels for document types.
 */
export const TYPE_LABELS: Record<DocumentType, string> = {
  [DocumentType.ANGEBOT]: 'Angebot',
  [DocumentType.AUFTRAG]: 'Auftrag',
  [DocumentType.LIEFERSCHEIN]: 'Lieferschein',
  [DocumentType.RECHNUNG]: 'Rechnung',
  [DocumentType.GUTSCHRIFT]: 'Gutschrift',
};

/**
 * Single-character abbreviation for compact badge display.
 */
export const TYPE_SHORT: Record<DocumentType, string> = {
  [DocumentType.ANGEBOT]: 'A',
  [DocumentType.AUFTRAG]: 'AU',
  [DocumentType.LIEFERSCHEIN]: 'L',
  [DocumentType.RECHNUNG]: 'R',
  [DocumentType.GUTSCHRIFT]: 'G',
};

/**
 * Inquiry types offered in the inquiry modal.
 */
export const INQUIRY_TYPES = [
  { value: 'PRICE', label: 'Preisanfrage' },
  { value: 'AVAILABILITY', label: 'Verfügbarkeit' },
  { value: 'RETURN', label: 'Rückgabe / Reklamation' },
  { value: 'OTHER', label: 'Sonstiges' },
] as const;

export type InquiryTypeValue = (typeof INQUIRY_TYPES)[number]['value'];

/**
 * Feature flag: also render TEXT hint lines (e.g. "Bei selbstständiger Abholung
 * von Ware", "Bruchersatz:") inside the grouped Sammelrechnung delivery cards.
 *
 * Flat (single-delivery) document views always show these hints; this flag only
 * governs the additional rendering inside grouped delivery cards. Set to `false`
 * to quickly revert to the previous behaviour (hints hidden in grouped views).
 */
export const SHOW_TEXT_HINTS_IN_GROUPED_VIEW = true;

/**
 * Tooltip shown on actions that only work for a single selected debitor
 * (favorites, cart, per-article CSV) — disabled in multi-customer/admin views.
 */
export const DISABLED_CUSTOMER_ACTION_TITLE =
  'Nur für einzelne Debitoren verfügbar';
